import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { reduxForm, Form, Field, change } from 'redux-form';
import { Row, Col, FormGroup, Alert, Button } from 'reactstrap';
import { PhoneField, TextField } from '@avinfors/redux-form-fields';

const LoginByPhone = ({
  form,
  dispatch,
  handleSubmit,
  submitOnEnter,
  error,
  submitting,
  valid,
  changeNumber
}) => {
  const { showSMSCodeForLogin } = useSelector(state => state.auth);

  useEffect(() => {
    if (!showSMSCodeForLogin) {
      dispatch(change(form, 'code', undefined));
    }
  }, [form, dispatch, showSMSCodeForLogin]);

  return (
    <Form onKeyDown={submitOnEnter(handleSubmit)} onSubmit={handleSubmit}>
      <div className='mb-2'>{showSMSCodeForLogin ? 'Код из СМС' : 'Номер телефона'}</div>
      <Row>
        {!showSMSCodeForLogin && (
          <Col md={6}>
            <FormGroup>
              <Field
                name='phone'
                component={PhoneField}
                placeholder='+7(___)__-__-___'
                inputMode='numeric'
                bsSize='lg'
              />
            </FormGroup>
          </Col>
        )}
        {showSMSCodeForLogin && (
          <Col md={6}>
            <FormGroup>
              <Field
                name='code'
                component={TextField}
                inputMode='numeric'
                bsSize='lg'
                maxLength='6'
              />
              <small className='c-pointer text-success' onClick={changeNumber}>
                Указать другой номер
              </small>
            </FormGroup>
          </Col>
        )}
        <Col md={6}>
          <FormGroup>
            <Button size='lg' block color='success' disabled={submitting}>
              {showSMSCodeForLogin ? 'Войти' : 'Получить код'}
            </Button>
          </FormGroup>
        </Col>
      </Row>
      {!!error && !valid && <Alert color='danger'>{error}</Alert>}
      {!error && (
        <Row>
          <Col className='text-muted mb-2'>
            Уважаемый клиент! Вход в личный кабинет доступен после прохождения первичной регистрации
            во вкладке «Регистрация».
          </Col>
        </Row>
      )}
    </Form>
  );
};

const validate = values => {
  if (!values) return {};

  const { phone, code } = values;

  if (!phone) {
    return {
      phone: 'Укажите номер телефона'
    };
  }

  if (!code) {
    return {
      code: 'Введите код из СМС'
    };
  }
};

export default reduxForm({
  form: 'loginByPhone',
  destroyOnUnmount: false,
  validate
})(LoginByPhone);
